export enum StopType {
  PICKUP = 1,
  DROPOFF = 2,
}

export enum StopTimeType {
  BEFORE = 1,
  AFTER = 2,
  BETWEEN = 3,
  ASAP_DELIVERY = 4,
}

export enum StopAddressType {
  ADDRESS = 1,
  AIRPORT = 2,
  SEAPORT = 3,
}

export enum ShipmentType {
  REGULAR = 1,
  CONSOLIDATED = 2,
  MULTIDROP = 3,
  MULTISTOP = 4,
}
